var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 11.0007C13.5311 11.0007 15.5832 8.94862 15.5832 6.41732C15.5832 3.88601 13.5311 1.83398 10.9998 1.83398C8.46853 1.83398 6.4165 3.88601 6.4165 6.41732C6.4165 8.94862 8.46853 11.0007 10.9998 11.0007Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.291C6.40748 13.291 2.66748 16.371 2.66748 20.166C2.66748 20.4227 2.86915 20.6243 3.12581 20.6243H18.8741C19.1308 20.6243 19.3325 20.4227 19.3325 20.166C19.3325 16.371 15.5925 13.291 11 13.291Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user-2.5e899cdaa3a38bc2eb33734bd9712f21.svg";
export { ForwardRef as ReactComponent };